import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const DATE_TIME_FORMAT = "MM/DD/YYYY HH:mm";

export const formatDateTimeWithOffset = (value: string | Date) => {
  const parsedValue = value instanceof Date ? dayjs(value) : dayjs(value, DATE_TIME_FORMAT, true);

  return parsedValue.format("YYYY-MM-DDTHH:mm:ssZ");
};
